import React, { useEffect, useState } from 'react'
import AgeIcon from "../../../images/ageIcon.png";
import BirthdayIcon from "../../../images/BirthdayIcon.png";
import MarritialStatusIcon from "../../../images/MarritialStatusIcon.png";
import ProfileEditIcon from "../../../images/ProfileEditIcon.png";
import Profileicon from "../../../images/Profileicon.png";
import heightIcon from "../../../images/heightIcon.png";
import chatIcons from "../../../images/chatIcons.png";
import locationIcon from "../../../images/locationIcon.png";
import salaryIcon from "../../../images/salaryIcon.png";
import BloodGroupIcon from "../../../images/BloodGroupIcon.png";
import AlternateIcon from "../../../images/AlternateIcon.png";
import CitizenshipIcon from "../../../images/CitizenshipIcon.png";
import GmailIcon from "../../../images/GmailIcon.png";
import NationalityIcon from "../../../images/NationalityIcon.png";
import phoneIcon from "../../../images/phoneIcon.png";
import neverIcon from "../../../images/neverIcon.png";
import educIcon from "../../../images/educIcon.png";
import jobIcon from "../../../images/jobIcon.png";
import MaleIcon from "../../../images/maleIcon.png";
import FemaleIcon from "../../../images/FemaleIcon.png";
import callIcon from "../../../images/callIcon.png";
import drinkIcon from "../../../images/drinkIcon.png";
import dietIcon from "../../../images/dietIcon.png";
import smokingIcon from "../../../images/smokingIcon.png";
import photoImg from "../../../images/photoImg.png";
import editIconBlack from "../../../images/editIconBlack.png";
import emailIcon from "../../../images/emailIcon.png";
import yearIcon from "../../../images/yearIcon.png";
import checkIconGreen from "../../../images/checkIconGreen.png";
import familyValueIcon from "../../../images/familyValueIcon.png";
import jointFamilyIcon from "../../../images/familyTypeIcon.png";
import familyStatusIcon from "../../../images/familyStatusIcon.png";
import familyOriginIcon from "../../../images/familyOriginIcon.png";
import FatherNameIcon from "../../../images/FatherNameIcon.png";
import FatherOccupationIcon from "../../../images/FatherOccupationIcon.png";
import MotherNameIcon from "../../../images/MotherNameIcon.png";
import MotherOccupationIcon from "../../../images/MotherOccupationIcon.png";
import Siblingsicon from "../../../images/Siblingsicon.png";
import { getFullProfileData } from '../../../asiosConfig';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import BodyType from "../../../images/BodyTypeIcon.png";
import Community from "../../../images/Community.png";
import Complexion from "../../../images/complexcion.png";
import DomainLang from "../../../images/Domain.png";
import GothramIcon from "../../../images/GothramIcon.png";
import PadamIcon from "../../../images/PadamIcon.png";
// import boyBanner from "../../../images/blankPicBoy1.png";
import MotherTongue from "../../../images/MotherTongue.png";
import PhysicalStatus from "../../../images/PhysicalStatusIcon.png";
import Religion from "../../../images/Religion.jpg";
import SevaiDosham from "../../../images/SevvaiDoshamIcon.png";
import StarIcon from "../../../images/StartIcon.png";
// import girlBanner from "../../../images/blankPic1.png";
import girlBanner from "../../../images/femaleMatch.png";
import boyBanner from "../../../images/maleMatch.png";
import SubCaste from "../../../images/SubCasteIcon.png";
import Weight from "../../../images/Weight.png";
import { ChildCare, ErrorOutline, PendingActions, Verified } from '@mui/icons-material';
import { Skeleton } from '@mui/material';

export const ViewUserProfile = () => {
    const [userProfileData, setUserProfileData] = useState('');
    const navigate = useNavigate();
    const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
    const bannerHeight = 263; // Height of the banner
    const gender = localStorage.getItem('gender');
    const [loading, setLoading] = useState(true);
    const defaultImage = gender === 'F' ? girlBanner : boyBanner;
    useEffect(() => {
        const fetchProfileData = async () => {
            // const tokan = localStorage.getItem('token');
            try {

                const response = await getFullProfileData();

                if (response.status === 200 || response.status === 201) {
                    localStorage.setItem('email', response.data.data.self.email)
                    setUserProfileData(response.data.data);
                } else {
                    toast.error("Error Fetching Profile Data");
                }
            } catch (error) {
                toast.error(error);
            } finally {
                setLoading(false);
            }
        }
        fetchProfileData();
    }, []);



    const imageUrl = userProfileData.self && userProfileData.self.photos
        ? userProfileData.self.photos
        : defaultImage;
    // Edit functionality
    const getImageSize = (url) => {
        const img = new Image();
        img.src = url;

        img.onload = () => {
            setImageSize({ width: img.width, height: img.height });
        };

        img.onerror = () => {
            console.error("Error loading image");
        };
    };

    // Call the function to get image size
    getImageSize(imageUrl);

    const isImageFit = imageSize.width > 0 && imageSize.height === bannerHeight;
    const userHobbies = userProfileData?.hobbies?.original || [];
    const handleEdit = (path, data) => {
        navigate(path, { state: { userProfileData: data } });
    }
    if (loading) {
        return (
            <div className='col-lg-9 col-12 text-left'>
                {/* Skeleton Loader for CardHeader */}
                <Skeleton variant="rectangular" width="100%" height={50} />
                {/* Skeleton Loader for Profile Details */}
                <Skeleton variant="rectangular" width="100%" height={bannerHeight} />
                <div style={{ display: 'flex', gap: '10px' }}>
                    <Skeleton variant="text" width="100px" height={30} />
                    <Skeleton variant="text" width="150px" height={30} />
                </div>
                {/* Skeleton Loader for Other Profile Details */}
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="rectangular" width="100%" height={bannerHeight} />
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="rectangular" width="100%" height={bannerHeight} />
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="text" width="100%" height={25} />
            </div>
        );
    }
    if (!userProfileData) return <p>No Profile Data Available.</p>; // Handle no data
    return (
        <div className="col-lg-9 col-12 text-left">
            <div className="editProfileBlock">
                <div className="profileBigImg">
                    {/* <img src={profileBigImg} alt="profile image" className="img-fluid" /> */}
                    <div
                        style={{
                            position: 'relative',
                            width: '100%',
                            height: `${bannerHeight}px`,
                            display: 'flex',
                            alignItems: 'center',
                            overflow: 'hidden',
                            border: '1px solid',
                        }}
                    >
                        {/* Left Blurred Section */}
                        {!isImageFit && (
                            <div
                                style={{
                                    flex: 1,
                                    height: '100%',
                                    backgroundImage: `url(${imageUrl})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    filter: 'blur(20px)',
                                }}
                            />
                        )}

                        {/* Center Image Section */}
                        <div
                            style={{
                                flex: 'none',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <img
                                src={imageUrl}
                                alt="profile"
                                style={{
                                    height: '100%',
                                    objectFit: isImageFit ? 'cover' : 'contain',
                                }}
                            />
                        </div>

                        {/* Right Blurred Section */}
                        {!isImageFit && (
                            <div
                                style={{
                                    flex: 1,
                                    height: '100%',
                                    backgroundImage: `url(${imageUrl})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    filter: 'blur(20px)',
                                }}
                            />
                        )}
                    </div>
                </div>
                <div className="idBlockBG">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="userid">
                            <h5><strong>ID - {userProfileData.self && userProfileData.self.username ? userProfileData.self.username : ''}</strong></h5>
                        </div>
                        <div>
                            <div>
                                <a className="btn photoBtn" href="javascript:void(0)" onClick={() => handleEdit('/upload-image', userProfileData.self)}><img src={photoImg} /> <span>Add Photos</span></a>
                                <a className="btn photoBtn" href="javascript:void(0)" onClick={() => handleEdit('/view-photos', userProfileData.self)}><img src={photoImg} /> <span>{userProfileData.self && userProfileData.self.photoCount ? userProfileData.self.photoCount : 0}</span> </a>
                                {/* <a href="javascript:void(0)"><img src={viewIcon} /></a> */}
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <div className="prodileDetailsBlock">
                    <div className="profileTlt">
                        <h3>Profile Details</h3>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '1rem',
                        padding: '1rem',
                        border: `1px solid ${userProfileData.self?.kycStatus === 'verified'
                            ? 'green'
                            : userProfileData.self?.kycStatus === 'pending'
                                ? 'orange'
                                : userProfileData.self?.kycStatus === 'rejected'
                                    ? 'red'
                                    : 'orange'
                            }`,
                        borderRadius: '8px',
                        backgroundColor: `${userProfileData.self?.kycStatus === 'verified'
                            ? '#e8f5e9'
                            : userProfileData.self?.kycStatus === 'pending'
                                ? '#fff3e0'
                                : userProfileData.self?.kycStatus === 'rejected'
                                    ? '#ffebee'
                                    : '#fff3e0'
                            }`
                    }}>
                        <div>
                            <p style={{
                                fontWeight: 'bold',
                                color: `${userProfileData.self?.kycStatus === 'verified'
                                    ? 'green'
                                    : userProfileData.self?.kycStatus === 'pending'
                                        ? 'orange'
                                        : userProfileData.self?.kycStatus === 'rejected'
                                            ? 'red'
                                            : 'orange'
                                    }`
                            }}>
                                {userProfileData.self?.kycStatus === 'verified'
                                    ? 'Your profile is verified.'
                                    : userProfileData.self?.kycStatus === 'pending'
                                        ? 'Your KYC Verification is under Processing'
                                        : userProfileData.self?.kycStatus === 'rejected'
                                            ? 'Your KYC Verification has been rejected.'
                                            : !userProfileData.self?.kycStatus ? ' Complete your profile KYC verification to ensure trust and authenticity.'
                                                : ''
                                }
                            </p>
                            {(userProfileData.self?.kycStatus === 'rejected' || !userProfileData.self?.kycStatus) && (
                                <a
                                    href="/kyc"
                                    style={{
                                        display: 'inline-block',
                                        marginTop: '0.5rem',
                                        textDecoration: 'none',
                                        color: 'blue',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    Click here to complete KYC verification
                                </a>
                            )}
                        </div>
                        <div>
                            {userProfileData.self?.kycStatus === 'verified' && (
                                <Verified style={{ color: 'green', fontSize: '2rem' }} />
                            )}
                            {userProfileData.self?.kycStatus === 'pending' && (
                                <PendingActions style={{ color: 'orange', fontSize: '2rem' }} />
                            )}
                            {userProfileData.self?.kycStatus === 'rejected' && (
                                <ErrorOutline style={{ color: 'red', fontSize: '2rem' }} />
                            )}
                            {!userProfileData.self?.kycStatus && (
                                <PendingActions style={{ color: 'orange', fontSize: '2rem' }} />
                            )}
                        </div>
                    </div>


                    <div className="boyProfileDetail">
                        <div className="d-flex justify-content-between align-items-between mt-3">
                            <div className="basicDetailTlt">
                                <p>Basic Details</p>
                            </div>
                            <div>
                                <a href="javascript:void(0)" onClick={() => handleEdit('/edit-basic-details', userProfileData.self)}><img src={editIconBlack} /></a>
                            </div>
                        </div>

                        <div className="personlDetails">
                            <p><img src={ProfileEditIcon} width="24" height="24" /> <span> Profile managed by {userProfileData.self && userProfileData.self.register_by_value ? userProfileData.self.register_by_value : ''}</span> </p>
                            <p><img src={Profileicon} width="24" height="24" /> <span> {userProfileData.self && userProfileData.self.name ? userProfileData.self.name : ''} {userProfileData.self && userProfileData.self.last_name ? userProfileData.self.last_name : ''}</span> </p>
                            <p><img src={BirthdayIcon} width="24" height="24" /> <span> {userProfileData.self && userProfileData.self.date_of_birth ?
                                new Date(userProfileData.self.date_of_birth).toLocaleDateString('en-GB', {
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric',
                                }) :
                                ''}</span>
                            </p>
                            <p><img src={AgeIcon} width="24" height="24" /> <span> {userProfileData.self && userProfileData.self.age ? userProfileData.self.age : ''}</span> </p>
                            <p>
                                {userProfileData.self && userProfileData.self.gender === 'M' ? (
                                    <>
                                        <img src={MaleIcon} width="24" height="24" /> <span>Male</span>
                                    </>
                                ) : userProfileData.self && userProfileData.self.gender === 'F' ? (
                                    <>
                                        <img src={FemaleIcon} width="24" height="24" /> <span>Female</span>
                                    </>
                                ) : ''}
                            </p>
                            <p><img src={MarritialStatusIcon} width="24" height="24" /> <span> {userProfileData.self && userProfileData.self.marital_status_value ? userProfileData.self.marital_status_value : ''} </span> </p>

                            {userProfileData.self && userProfileData.self.no_of_Children ? (
                                <p>
                                    <img src={ChildCare} width="24" height="24" /> <span> Have Child -
                                        {userProfileData.self.no_of_Children.charAt(0).toUpperCase() + userProfileData.self.no_of_Children.slice(1)} </span>
                                </p>
                            ) : null}

                            {userProfileData.self && userProfileData.self.childrenLivingStatus ? (
                                <p>
                                    <img src={ChildCare} width="24" height="24" alt="Child Care" /> <span>
                                        {userProfileData.self.childrenLivingStatus.charAt(0).toUpperCase() + userProfileData.self.childrenLivingStatus.slice(1)} </span>
                                </p>
                            ) : null}

                            <div className="d-flex justify-content-between align-items-between">
                                <p> <img src={BloodGroupIcon} width="24" height="24" alt="Blood Group" /><span> Blood Group - {userProfileData.self && userProfileData.self.blood_name ? userProfileData.self.blood_name : ''} </span></p>
                            </div>
                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={heightIcon} width="24" height="24" /> <span> Height - {userProfileData.self && userProfileData.self.height ? userProfileData.self.height : 'Height Not Avaialble'} </span></p>
                            </div>

                        </div>
                        <div className="personlDetails">
                            {/* <p><img src={educIcon} width="24" height="24" /> <span>{userProfileData.self && userProfileData.self.educations ? userProfileData.self.educations : ''}</p> */}

                            <div className="my-2 add_data">
                                <p className="aboutfil">About me</p>
                                <p><span>{userProfileData.self && userProfileData.self.about_me ? userProfileData.self.about_me : ''} </span></p>
                            </div>
                        </div>
                    </div>

                    <div className="boyProfileDetail">
                        <div className="d-flex justify-content-between align-items-between mt-3">
                            <div className="basicDetailTlt">
                                <p>Education & Profession</p>
                            </div>
                            <div>
                                <a href="javascript:void(0)" onClick={() => handleEdit('/edit-professional-details', userProfileData.self)}> <img src={editIconBlack} /></a>
                            </div>
                        </div>
                        <div className="personlDetails">
                            <p><img src={educIcon} width="24" height="24" /> <span> {userProfileData.self && userProfileData.self.educations ? userProfileData.self.educations : ''} </span></p>

                            <div className="my-2 add_data">
                                <p className="aboutfil">About my education</p>
                                <p> {userProfileData.self && userProfileData.self.educationDetail ? userProfileData.self.educationDetail : ''}</p>
                            </div>
                        </div>
                        <div className="personlDetails">
                            <p><img src={jobIcon} width="24" height="24" /> <span> {userProfileData.self && userProfileData.self.occupation ? userProfileData.self.occupation : ''}</span></p>
                            <div className="my-2 add_data">
                                <p className="aboutfil">About my career</p>
                                <p> {userProfileData.self && userProfileData.self.occupationDetail ? userProfileData.self.occupationDetail : ''}</p>
                            </div>

                            <p><img src={salaryIcon} width="24" height="24" /> <span> {userProfileData.self && userProfileData.self.income_value ? `Salary. ${userProfileData.self.income_value} P.A` : ''}</span></p>
                            <p><img src={locationIcon} width="24" height="24" /> <span> {userProfileData.self && userProfileData.self.residingCity ? userProfileData.self.residingCity : 'City '}, {userProfileData.self && userProfileData.self.residingState ? userProfileData.self.residingState : ''}, {userProfileData.self && userProfileData.self.residingCountry ? userProfileData.self.residingCountry : ''}</span></p>
                        </div>


                    </div>

                    <div className="boyProfileDetail">
                        <div className="d-flex justify-content-between align-items-between mt-3">
                            <div className="basicDetailTlt">
                                <p>Family Details</p>
                            </div>
                            <div>
                                <a href="javascript:void(0)" onClick={() => handleEdit('/edit-family-details', userProfileData.self)}><img src={editIconBlack} /></a>
                            </div>
                        </div>
                        <div className="personlDetails">
                            <p><img src={FatherNameIcon} width="24" height="24" /> <span> Father Name - {userProfileData.self && userProfileData.self.fatherName ? userProfileData.self.fatherName : ''}</span></p>
                            <p><img src={FatherOccupationIcon} width="24" height="24" /> <span> Father's Profession - {userProfileData.self && userProfileData.self.fatherProfessions ? userProfileData.self.fatherProfessions : ''}</span></p>
                            <p><img src={MotherNameIcon} width="24" height="24" /> <span> Mother Name - {userProfileData.self && userProfileData.self.motherName ? userProfileData.self.motherName : ''}</span></p>
                            <p><img src={MotherOccupationIcon} width="24" height="24" /> <span> Mother's Profession - {userProfileData.self && userProfileData.self.motherProfession ? userProfileData.self.motherProfession : ''}</span></p>
                            <p>
                                <img src={Siblingsicon} alt="family professions" width="24" height="24" /> <span> Siblings -
                                    {userProfileData.self && (
                                        (userProfileData.self.unMarriedBrothers !== undefined || userProfileData.self.marriedBrothers !== undefined) &&
                                        (userProfileData.self.unMarriedSister !== undefined || userProfileData.self.marriedSister !== undefined)
                                    ) ? ' ' : ''}

                                    {userProfileData.self && (
                                        (userProfileData.self.unMarriedBrothers || userProfileData.self.marriedBrothers || 0) > 0
                                    ) ? `${(userProfileData.self.unMarriedBrothers || 0) + (userProfileData.self.marriedBrothers || 0)} Brother's (${(userProfileData.self.marriedBrothers || 0) > 0 ? userProfileData.self.marriedBrothers : 0} married)` : ''}

                                    {userProfileData.self && (
                                        (userProfileData.self.unMarriedBrothers !== undefined || userProfileData.self.marriedBrothers !== undefined) &&
                                        (userProfileData.self.unMarriedSister !== undefined || userProfileData.self.marriedSister !== undefined)
                                    ) ? '  ' : ''}

                                    {userProfileData.self && (
                                        (userProfileData.self.unMarriedSister || userProfileData.self.marriedSister || 0) > 0
                                    ) ? `${(userProfileData.self.unMarriedSister || 0) + (userProfileData.self.marriedSister || 0)} Sister's (${(userProfileData.self.marriedSister || 0) > 0 ? userProfileData.self.marriedSister : 0} married)` : ''}
                                </span>

                            </p>
                            <div className="family-section">
                                {(!userProfileData?.self?.family_values &&
                                    !userProfileData?.self?.family_types &&
                                    !userProfileData?.self?.family_status &&
                                    !userProfileData?.self?.familyOrigin) ? (
                                    <div className="d-flex justify-content-between align-items-between">
                                        <p>Family Status, Family Value, Gothra, Married Brother(s), Living with parents?</p>
                                    </div>
                                ) : (
                                    <div>
                                        <p>
                                            <img src={familyValueIcon} width="24" height="24" alt="Family Value Icon" />
                                            <span> Family Value - {userProfileData?.self?.family_values || ''} </span>
                                        </p>
                                        <p>
                                            <img src={jointFamilyIcon} width="24" height="24" alt="Family Type Icon" />
                                            <span> Family Type - {userProfileData?.self?.family_types || ''} </span>
                                        </p>
                                        <p>
                                            <img src={familyStatusIcon} width="24" height="24" alt="Family Status Icon" />
                                            <span> Family Status - {userProfileData?.self?.family_status || ''} </span>
                                        </p>
                                        <p>
                                            <img src={familyOriginIcon} width="24" height="24" alt="Family Origin Icon" />
                                            <span> Family Origin - {userProfileData?.self?.familyOrigin || ''} </span>
                                        </p>
                                    </div>
                                )}
                            </div>

                            <div className="my-2 add_data">
                                <p className="aboutfil">About my family</p>
                                <p>{userProfileData.self && userProfileData.self.aboutFamily ? userProfileData.self.aboutFamily : ''}</p>
                            </div>
                        </div>
                    </div>

                    <div className="boyProfileDetail">
                        <div className="d-flex justify-content-between align-items-between mt-3">
                            <div className="basicDetailTlt">
                                <p>Contact Details</p>
                            </div>
                            <div>
                                <a href="javascript:void(0)" onClick={() => handleEdit('/edit-contact-details', userProfileData.self)}><img src={editIconBlack} /></a>
                            </div>
                        </div>
                        <div className="personlDetails">
                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={GmailIcon} width="24" height="24" /> <span> {userProfileData.self && userProfileData.self.email ? userProfileData.self.email : ''}</span></p>
                            </div>
                            <div>
                                <p><img src={phoneIcon} width="24" height="24" /> <span> {userProfileData.self && userProfileData.self.mobileNumber ? userProfileData.self.mobileNumber : ''}</span></p>
                            </div>
                            <div className="d-flex justify-content-between align-items-between">
                                <div>
                                    <div>
                                        <p><img src={AlternateIcon} width="24" height="24" /> <span> Alternate No - {userProfileData.self && userProfileData.self.phoneNumber ? userProfileData.self.phoneNumber : ''}</span></p>
                                    </div>
                                </div>
                            </div>
                            <p>
                                <img src={locationIcon} width="24" height="24" />
                                <span>
                                    Address - {
                                        [
                                            userProfileData.self?.streetAddress,
                                            userProfileData.self?.area,
                                            userProfileData.self?.city,
                                            userProfileData.self?.state,
                                            userProfileData.self?.country,
                                            userProfileData.self?.pincode,
                                        ]
                                            .filter(Boolean) // Filters out falsy values like undefined, null, or empty strings
                                            .join(', ') // Joins the remaining values with a comma
                                    }
                                </span>
                            </p>

                            <p><img src={CitizenshipIcon} width="24" height="24" /> <span> Citizenship - {userProfileData.self && userProfileData.self.citizenship_value ? userProfileData.self.citizenship_value : ''}</span></p>
                            <p><img src={NationalityIcon} width="24" height="24" /> <span> Nationality - {userProfileData.self && userProfileData.self.nationality_value ? userProfileData.self.nationality_value : ''}</span></p>

                        </div>
                    </div>

                    <div className="boyProfileDetail">
                        <div className="d-flex justify-content-between align-items-between mt-3">
                            <div className="basicDetailTlt">
                                <p>Religion Kundli and Astro Details</p>
                            </div>
                            <div>
                                <a href="javascript:void(0)" onClick={() => handleEdit('/edit-religion-details', userProfileData.self)}><img src={editIconBlack} /></a>
                            </div>
                        </div>
                        <div className="personlDetails">
                            {/* <div className="d-flex justify-content-between align-items-between">
                                <p><img src={kundliIcon} width="24" height="24" /> <span> Simha - {userProfileData.self && userProfileData.self.manglik ? userProfileData.self.manglik : ''} - Nakshatra</p>
                            </div> */}
                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={DomainLang} width="24" height="24" /> <span> Domain - {userProfileData.self && userProfileData.self.domain ? userProfileData.self.domain : ''}</span></p>
                            </div>
                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={Religion} width="24" height="24" /> <span> Religion - {userProfileData.self && userProfileData.self.religion ? userProfileData.self.religion : ''}</span></p>
                            </div>
                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={Community} width="24" height="24" /> <span> Community - {userProfileData.self && userProfileData.self.caste ? userProfileData.self.caste : ''}</span></p>
                            </div>
                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={SubCaste} width="24" height="24" /> <span> Sub Caste - {userProfileData.self && userProfileData.self.subcaste ? userProfileData.self.subcaste : ''}</span></p>
                            </div>
                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={GothramIcon} width="24" height="24" /> <span> Gothram - {userProfileData.self && userProfileData.self.gothram ? userProfileData.self.gothram : ''}</span></p>
                            </div>
                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={StarIcon} width="24" height="24" /> <span> Star - {userProfileData.self && userProfileData.self.star_value ? userProfileData.self.star_value : ''}</span></p>
                            </div>
                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={PadamIcon} width="24" height="24" /> <span> Padam - {userProfileData.self && userProfileData.self.padam_value ? userProfileData.self.padam_value : ''}</span></p>
                            </div>
                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={SevaiDosham} width="24" height="24" /> <span> Sevvai Dosham - {userProfileData.self && userProfileData.self.sevvaiDosham ? userProfileData.self.sevvaiDosham : ''}</span></p>
                            </div>
                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={MotherTongue} width="24" height="24" /> <span> Mother Tongue - {userProfileData.self && userProfileData.self.mother_tongue_value ? userProfileData.self.mother_tongue_value : ''}</span></p>
                            </div>
                            {/* <div>
                                <p><img src={locationIcon} width="24" height="24" /> <span>   {userProfileData.self && userProfileData.self.date_of_birth ?
                                    new Date(userProfileData.self.date_of_birth).toLocaleDateString('en-GB', {
                                        day: 'numeric',
                                        month: 'long',
                                        year: 'numeric',
                                    }) :
                                    ''} - {userProfileData.self && userProfileData.self.time_of_birth ? userProfileData.self.time_of_birth : ''} - Born in {userProfileData.self && userProfileData.self.place_of_birth ? userProfileData.self.place_of_birth : ''}</p>
                            </div>

                            <div className="d-flex justify-content-between align-items-between">
                                <p>Thoughts on Horoscope</p>
                                <p className="addTxt"><a href="kundliEdit.html">Add</a></p>
                            </div>
                            <div className="text-center mb-2">
                                <a href="#"><img src={patrikaImg} className="img-fluid" /></a>
                            </div> */}
                        </div>
                    </div>

                    <div className="boyProfileDetail">
                        <div className="d-flex justify-content-between align-items-between mt-3">
                            <div className="basicDetailTlt">
                                <p>My Lifestyle & Interests</p>
                            </div>
                            <div>
                                <a href="javascript:void(0)" onClick={() => handleEdit('/edit-lifeStyle-details', userProfileData.self)}><img src={editIconBlack} /></a>
                            </div>
                        </div>
                        <div className="personlDetails">


                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={Weight} width="24" height="24" /> <span> Weight - {userProfileData.self && userProfileData.self.weight_value ? userProfileData.self.weight_value : ''}</span></p>
                            </div>
                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={PhysicalStatus} width="24" height="24" /> <span> Physical Status - {userProfileData.self && userProfileData.self.physical_status_value ? userProfileData.self.physical_status_value : ''}</span></p>
                            </div>
                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={BodyType} width="24" height="24" /> <span> Body Type - {userProfileData.self && userProfileData.self.body_type_value ? userProfileData.self.body_type_value : ''}</span></p>
                            </div>
                            <div className="d-flex justify-content-between align-items-between">
                                <p><img src={Complexion} width="24" height="24" /> <span> Complexion - {userProfileData.self && userProfileData.self.complexion_value ? userProfileData.self.complexion_value : ''}</span></p>
                            </div>
                            <div className="mt-2">
                                <p><b>Habits</b></p>
                                <div className="row d-flex">
                                    <p className="habitsSec col-md-3"><img src={drinkIcon} width="24" height="24" /><span> {userProfileData.self && userProfileData.self.drink_value ? userProfileData.self.drink_value : ''}</span></p>
                                    <p className="habitsSec col-md-3"><img src={dietIcon} width="24" height="24" /><span> {userProfileData.self && userProfileData.self.eating_value ? userProfileData.self.eating_value : ''}</span></p>
                                    <p className="habitsSec col-md-3"><img src={smokingIcon} width="24" height="24" /><span>{userProfileData.self && userProfileData.self.smoke_value ? userProfileData.self.smoke_value : ''}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="boyProfileDetail">
                        <div className="d-flex justify-content-between align-items-between mt-3">
                            <div className="basicDetailTlt">
                                <p>Hobbies</p>
                            </div>
                            <div>
                                <a href="javascript:void(0)" onClick={() => handleEdit('/hobbies', userProfileData.self)}><img src={editIconBlack} /></a>
                            </div>
                        </div>
                        <div className="detailTlts">
                            {userHobbies.length > 0 ? (
                                userHobbies.map((hobbyType, index) => (
                                    <div key={index} className="mt-2">
                                        <p><b>
                                            My Favourites {hobbyType.hobbies_type.type
                                                .replace(/^Favourite_/, '')
                                                .replace(/^Favorite/, '')
                                                .replace(/_/g, ' ')}
                                        </b></p>
                                        <div className="hoibisSec">
                                            {hobbyType.hobbies_type.hobbies.map((hobby, hobbyIndex) => (
                                                <p key={hobbyIndex} style={{ margin: '10px' }}>{hobby}</p>
                                            ))}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>No hobbies found.</p>
                            )}
                        </div>

                    </div>
                    <div className="profileTlt">
                        <h3>Partners Profile Details</h3>
                    </div>
                    <div className="boyProfileDetail">
                        <div className="d-flex justify-content-between align-items-between mt-3">
                            <div className="basicDetailTlt">
                                <p>Partner's Basic Details</p>
                            </div>
                            <div>
                                <a href="javascript:void(0)" onClick={() => handleEdit('/edi-partner-basic-details', userProfileData.self)}><img src={editIconBlack} /></a>
                            </div>
                        </div>
                        <div className="personlDetails">
                            <p><img src={AgeIcon} width="24" height="24" /> <span>{userProfileData.self && userProfileData.self.ageFrom ? userProfileData.self.ageFrom : 'Not Availabe'} to {userProfileData.self && userProfileData.self.ageTo ? userProfileData.self.ageTo : 'Not Availabe'} Years
                            </span></p>
                            <p><img src={heightIcon} width="24" height="24" /> <span> {userProfileData.partner && userProfileData.partner.partnerHeightFrom ? `${userProfileData.partner.partnerHeightFrom} ft` : ''} - {userProfileData.partner && userProfileData.partner.partnerHeightTo ? `${userProfileData.partner.partnerHeightTo} ft` : ''}</span></p>
                            {/* <p><img src={locationIcon} width="24" height="24" /> <span> India</span></p> */}
                            <p><img src={neverIcon} width="24" height="24" /> <span> {userProfileData.partner && userProfileData.partner.partner_marital_status_value ? userProfileData.partner.partner_marital_status_value : ''}</span></p>
                            <p><img src={PhysicalStatus} width="24" height="24" /> <span> Physical Status - {userProfileData.partner && userProfileData.partner.partnerPhysicalStatus_value ? userProfileData.partner.partnerPhysicalStatus_value : userProfileData?.partner?.partnerPhysicalStatus}</span></p>
                        </div>
                    </div>

                    <div className="boyProfileDetail">
                        <div className="d-flex justify-content-between align-items-between mt-3">
                            <div className="basicDetailTlt">
                                <p>Partner's Education and Profession</p>
                            </div>
                            <div>
                                <a href="javascript:void(0)" onClick={() => handleEdit('/edit-parter-professional-details', userProfileData.partner)}><img src={editIconBlack} /></a>
                            </div>
                        </div>
                        <div className="personlDetails" >
                            <p><img src={educIcon} width="24" height="24" /> <span> Education could be -{userProfileData.partner && userProfileData.partner.partnerEducation ? `${userProfileData.partner.partnerEducation}` : ''}</span></p>
                            <p><img src={jobIcon} width="24" height="24" /> <span> Profession could be - {userProfileData.partner && userProfileData.partner.partnerOccupation ? `${userProfileData.partner.partnerOccupation}` : ''}</span> </p>
                            <p><img src={salaryIcon} width="24" height="24" /> <span> Should be Earning -  {userProfileData.partner && userProfileData.partner.partnerIncomes ? `Rs. ${userProfileData.partner.partnerIncomes}` : ''}</span></p>
                            <p><img src={locationIcon} width="24" height="24" /> <span> Residing Country - {userProfileData.partner && userProfileData.partner.partnerCountryLivings ? userProfileData.partner.partnerCountryLivings : ''} </span></p>
                            <p><img src={locationIcon} width="24" height="24" /> <span> Residing State -  {userProfileData.partner && userProfileData.partner.partnerResidingState ? userProfileData.partner.partnerResidingState : ''}</span> </p>
                            <p><img src={locationIcon} width="24" height="24" /> <span> Residing City - {userProfileData.partner && userProfileData.partner.partnerResidingCity ? userProfileData.partner.partnerResidingCity : ''}</span> </p>
                        </div>
                    </div>
                    <div className="boyProfileDetail">
                        <div className="d-flex justify-content-between align-items-between mt-3">
                            <div className="basicDetailTlt">
                                <p>Partner's Native Location</p>
                            </div>
                            <div>
                                <a href="javascript:void(0)" onClick={() => handleEdit('/edit-parter-native-place-details', userProfileData.partner)}><img src={editIconBlack} /></a>
                            </div>
                        </div>
                        <div className="personlDetails">
                            <p><img src={educIcon} width="24" height="24" /> <span> Country - {userProfileData.partner && userProfileData.partner.partnerNativeCountries ? userProfileData.partner.partnerNativeCountries : ''}</span></p>
                            <p><img src={jobIcon} width="24" height="24" /> <span> State - {userProfileData.partner && userProfileData.partner.partnerNativeStates ? userProfileData.partner.partnerNativeStates : ''}</span> </p>
                            <p><img src={locationIcon} width="24" height="24" /> <span> City - {userProfileData.partner && userProfileData.partner.partnerNativeCities ? userProfileData.partner.partnerNativeCities : ''}</span></p>
                            <p><img src={locationIcon} width="24" height="24" /> <span> Citizenship - {userProfileData.partner && userProfileData.partner.partnerNativeCitizenships ? userProfileData.partner.partnerNativeCitizenships : ''}</span></p>
                        </div>
                    </div>




                    <div className="boyProfileDetail">
                        <div className="d-flex justify-content-between align-items-between mt-3">
                            <div className="basicDetailTlt">
                                <p>Partner's Religion Kundli and Astro</p>
                            </div>
                            <div>
                                <a href="javascript:void(0)" onClick={() => handleEdit('/edit-partner-religion-social-details', userProfileData.partner)}><img src={editIconBlack} /></a>
                            </div>
                        </div>
                        <div className="personlDetails">
                            <p><img src={DomainLang} width="24" height="24" /> <span> Domain - {userProfileData.self && userProfileData.partner.partnerDomain ? userProfileData.partner.partnerDomain : ''}</span></p>
                            <p><img src={Religion} width="24" height="24" /> <span> Religion -{userProfileData.partner && userProfileData.partner.partnerReligion ? `${userProfileData.partner.partnerReligion}` : ''}</span></p>

                            <p><img src={Community} width="24" height="24" /> <span> Community - {userProfileData.partner && userProfileData.partner.partnerCaste ? userProfileData.partner.partnerCaste : ''}</span></p>
                            <p><img src={MotherTongue} width="24" height="24" /> <span> Mother Tongue - {userProfileData.partner && userProfileData.partner.partner_mother_tongue_value ? `${userProfileData.partner.partner_mother_tongue_value}` : ''}</span></p>
                            <p><img src={SevaiDosham} width="24" height="24" /> <span> Sevvai Dosham - {userProfileData.partner && userProfileData.partner.partnerSevvaiDosham ? userProfileData.partner.partnerSevvaiDosham : ''}</span></p>
                        </div>
                    </div>

                    <div className="boyProfileDetail">
                        <div className="d-flex justify-content-between align-items-between mt-3">
                            <div className="basicDetailTlt">
                                <p>Partner's Lifestyle and Appearance</p>
                            </div>
                            <div>
                                <a href="javascript:void(0)" onClick={() => handleEdit('/edit-partner-lifestyle-appearance-details', userProfileData.partner)}><img src={editIconBlack} /></a>
                            </div>
                        </div>
                        <div className="personlDetails">
                            <p>
                                <img src={drinkIcon} alt="Drink Icon" width="24" height="24" /> <span>
                                    {userProfileData.partner && userProfileData.partner.partner_drinking_habits
                                        ? `Drinking Habits - ${userProfileData.partner.partner_drinking_habits === 1 ? 'Non-drinker' :
                                            userProfileData.partner.partner_drinking_habits === 2 ? 'Light / Social drinker' :
                                                userProfileData.partner.partner_drinking_habits === 3 ? 'Regular drinker' :
                                                    "Doesn't Matter"

                                        }`
                                        : 'Drinking Habits - '}
                                </span></p>
                            <p>
                                <img src={dietIcon} alt="Diet Icon" width="24" height="24" /> <span> Eating Habits - {userProfileData.partner && userProfileData.partner.partner_eating_habbit_value ? userProfileData.partner.partner_eating_habbit_value : ''}
                                </span></p>
                            <p><img src={smokingIcon} width="24" height="24" /> <span> {userProfileData.partner && userProfileData.partner.partner_smoking_habits
                                ? `Smoking Habits - ${userProfileData.partner.partner_smoking_habits === 1 ? 'Non-smoker' :
                                    userProfileData.partner.partner_smoking_habits === 2 ? 'Light / Social smoker' :
                                        userProfileData.partner.partner_smoking_habits === 3 ? 'Regular smoker' :
                                            "Doesn't Matter"
                                }`
                                : 'Smoking Habits - '}</span></p>
                            {/* <p><img src={casesIcon} /> <span> Special Cases - Doesn't Matter</span></p> */}
                            <p><img src={PhysicalStatus} width="24" height="24" /> <span> Physical Status - {userProfileData.partner && userProfileData.partner.partnerPhysicalStatus ? userProfileData.partner.partnerPhysicalStatus : ''}</span></p>
                            <p><img src={Complexion} width="24" height="24" /> <span> Complexion - {userProfileData.partner && userProfileData.partner.partner_complexion_value ? userProfileData.partner.partner_complexion_value : ''}</span></p>
                        </div>
                    </div>

                    <div className="boyProfileDetail">
                        <div className="d-flex justify-content-between align-items-between mt-3">
                            <div className="basicDetailTlt">
                                <p>About My Partner</p>
                            </div>
                            <div>
                                <a href="javascript:void(0)" onClick={() => handleEdit('/edit-about-partner', userProfileData.partner)}><img src={editIconBlack} /></a>
                            </div>
                        </div>
                        <div className="personlDetails">
                            <div className="my-2 add_data">
                                <p>{userProfileData.partner && userProfileData.partner.aboutLifePartner ? `${userProfileData.partner.aboutLifePartner}` : ''}</p>
                            </div>
                        </div>
                        {/* <div className="boyProfileDetail mt-3">
                            <div className="d-flex justify-content-between align-items-between mt-3">
                                <div className="strictTxt">
                                    <p>Strict filters affect your matches</p>
                                    <p className="catopara">Age, Marital Status, Country, City, Religion, Caste, Mother Tongue, Income</p>
                                </div>
                                <div>
                                    <a className="btn manageBtn" href="manage.html">Manage</a>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}
